import React from "react";
import { useNavigate } from "react-router-dom";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

import styles from "./BranchesList.module.scss";

const handleOnClickBranch = (branchId, navigate) => {
  navigate(`/branchDetails?branchId=${branchId}`);
};

const BranchesList = ({ branches }) => {
  const navigate = useNavigate();

  return (
    <ul className={styles.branchList}>
      {branches.map((branch) => {
        const branchId = branch.branchId || branch.id;
        const branchName = branch.branchName || branch.name;

        return (
          <li key={branchId} className={styles.branchListItem}>
            <button
              type="button"
              className={styles.branchItem}
              onClick={() => handleOnClickBranch(branchId, navigate)}
              aria-label={`View details for ${branchName}`}
            >
              <div className={styles.cardTop}>
                <div className={styles.branchTitleBlock}>
                  <span className={styles.branchName}>{branchName}</span>
                </div>
                {branch.tenantName ? (
                  <span className={styles.tenantBadge} title={branch.tenantName}>
                    {branch.tenantName}
                  </span>
                ) : null}
              </div>
              <div className={styles.metaGrid}>
                <div className={styles.metaRow}>
                  <EmailOutlinedIcon className={styles.metaIcon} aria-hidden />
                  <span className={styles.srOnly}>Email</span>
                  <span className={styles.metaValue} title={branch.email || undefined}>
                    {branch.email || "—"}
                  </span>
                </div>
                <div className={styles.metaRow}>
                  <LocationOnOutlinedIcon className={styles.metaIcon} aria-hidden />
                  <span className={styles.srOnly}>City</span>
                  <span
                    className={styles.metaValue}
                    title={branch.address?.city || undefined}
                  >
                    {branch.address?.city || "—"}
                  </span>
                </div>
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default BranchesList;
